import { render, staticRenderFns } from "./AdminV2CountdownBanner.vue?vue&type=template&id=654dff5a&scoped=true"
import script from "./AdminV2CountdownBanner.vue?vue&type=script&lang=js"
export * from "./AdminV2CountdownBanner.vue?vue&type=script&lang=js"
import style0 from "./AdminV2CountdownBanner.vue?vue&type=style&index=0&id=654dff5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654dff5a",
  null
  
)

export default component.exports